export const getUserLocation = async <T extends Location = Location>(coordinates: GeolocationCoordinates): Promise<T> =>
    await fetch(
        `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${coordinates.latitude}&longitude=${coordinates.longitude}&localityLanguage=en`
    )
        .then((response) => response.json())
        .catch((error) => console.log(error))

export interface Location {
    countryCode: string
    countryName: string
    city: string
    continent: string
    continentCode: string
    latitude: number
    longitude: number
    coords: string
}
